export class PraticaLinguagem {
  constructor({
    id = null,
    nome = null,
    habilidades = Array(),
    descricao = null,
  }) {
    this.id = id;
    this.nome = nome;
    this.habilidades = habilidades;
    this.descricao = descricao;
  }
  static Build() {
    return new PraticaLinguagem({
      id: null,
      nome: null,
      habilidades: Array(),
      descricao: null,
    });
  }
  formatParaEnviar() {
    return {
      ...this,
      habilidadesId: this.habilidades.map(h => h.id),
    };
  }
}
